module.exports = __webpack_public_path__ + "static/media/Calendar.f205b932.svg";